import React, { useState, useEffect } from 'react';


const SessionSelectionInPage = ({ sessions, handleSessionSelection }) => {
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [selectedSession, setSelectedSession] = useState(null);

  const handleSelection = (session) => {
    setButtonDisabled(session.sold_out);
    if (!session.sold_out) {
      setSelectedSession(session);
    } else {
      setSelectedSession(null);
    }
  };

  // console.log(sessions);

  const first_session = sessions[0];
  const last_session = (sessions.length > 1) ? sessions[sessions.length - 1] : false;
  const sessions_length = sessions.length;

  useEffect(() => {
    if (sessions_length === 1) {
      handleSelection(first_session);
    }
  }, []);

  return (
    <div className='flex flex-column'>
      <div className='m1'>
        <h4 className='mb-0'>Choose a session time</h4>
        <p className='mt-0 tiny'>
          <time dateTime=''>{first_session.start_date_human}</time>
          {last_session && (
            <>
              &mdash;
              <time dateTime=''>{last_session.start_date_human}</time>
            </>
          )}
        </p>

        <ul className='list-none event-page__sessions p0'>
          {sessions.map(session => (
            <li key={session.id} className='sm:flex md:block md+:flex flex-jc-between flex-ai-center mb-4 pl-0'>
              <div className='mr-4 md:mr-0'>
                <label htmlFor={`label-${session.id}`} className='tiny font-normal mr-4 md:mr-0'>
                  <input
                    onClick={() => handleSelection(session)}
                    className='mr-2'
                    type='radio'
                    id={`label-${session.id}`}
                    name='sessions'
                    defaultChecked={sessions_length === 1}
                  />
                  <time dateTime={session.start_date_human}>
                    {session.start_date_human}
                    {session.start_time_human && (
                      <>
                        ,
                        {' '}
                        {session.start_time_human}
                      </>
                    )}
                  </time>
                </label>
              </div>
              {session.status && !session.status.toLowerCase().includes('none') && (
                <span className='tiny color-red pb-2'>
                  {session.status}
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
      <button
        disabled={buttonDisabled}
        onClick={() => handleSessionSelection(selectedSession)}
        className='btn btn--default btn--large px-3 flex-grow-1'
      >
        Buy Tickets
      </button>
    </div>
  );
};

export default SessionSelectionInPage;
